'use client';

import React, { ComponentProps, MouseEvent, ReactElement } from 'react';
import styled from 'styled-components';

import Toggle, { ToggleProps } from '../Toggle';

import Default from './Menu.default';
import useTranslation from '../../translation/useTranslation';

import Link from './Link';
import Accordion from './Accordion';
import Spacer from './Spacer';
import Group from './Group';
import Grid from './Grid';
import { useNavbar } from '../state';

interface MenuProps extends Partial<ToggleProps> {
  children?:
  | ReactElement<ComponentProps<typeof Link>>
  | ReactElement<ComponentProps<typeof Link>>[];
}

function Menu({
  id = 'menu',
  trackid = 'menu-1_expand|Meny',
  title = '',
  icon = <i aria-hidden>menu</i>,
  children,
}: MenuProps) {
  const { t } = useTranslation();

  const { navbarProps } = useNavbar();

  const logout = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    navbarProps?.logout?.();
  };

  return (
    <Toggle
      id={id}
      trackid={trackid}
      hideTextOnMobile={false}
      title={title || t('menu.text')}
      icon={icon}
    >
      <Content>
        <Grid>
          <Grid.Item
            onClick={logout}
            data-trackid={`menu-2_link|${t('logout.text')}`}
            icon="unlock"
          >
            {t('logout.text')}
          </Grid.Item>
          <Grid.Item
            href={t('language.href')}
            data-trackid={`menu-2_link|${t('language.text')}`}
            icon="globe"
          >
            {t('language.text')}
          </Grid.Item>
          <Grid.Item
            href={t('contact.href')}
            data-trackid={`menu-2_link|${t('contact.text')}`}
            icon="support"
          >
            {t('contact.text')}
          </Grid.Item>
        </Grid>
        {children || <Default />}
      </Content>
    </Toggle>
  );
}

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

Menu.Link = Link;
Menu.Accordion = Accordion;
Menu.Spacer = Spacer;
Menu.Group = Group;
Menu.Grid = Grid;

export default Menu;
